(function() {
  'use strict';
  angular.module('admin')
  .controller('userSearchController', ['adminUsers', '$uibModal', 'uiGridConstants', '$scope', 'secSecurityService', 'Dso',
    function(Users, $uibModal, uiGridConstants, $scope, secSecurityService, Dso) {
    var vm = this;
    vm.model = {};
    vm.submit = submit;
    vm.reset = reset;
    vm.running = false;
    vm.showGrid = false;
    Dso.query({status: 'REGISTERED'}, (dsos) => {
      vm.registeredDsos = dsos;
      vm.dsoNames = _.map(vm.registeredDsos, (dso) => dso.name);
    });
    vm.userSearchGridOptions = {
      enableSorting: true,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      exporterMenuPdf: false,
      noUnselect: true,
      modifierKeysToMultiSelect: true,
      enableGridMenu: true,
      columnDefs: [
        { field: 'userId', displayName: 'User ID', sort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }},
        { field: 'userType', cellFilter: 'userStatus:row.entity.userType' },
        { field: 'firstName' },
        { field: 'lastName' },
        { field: 'verifiedEmail' },
        { field: 'unverifiedEmail' },
        { field: 'getTaxId()', displayName: 'Tax ID'},
        { field: 'dsoProfile.name', displayName: 'DSO'},
        { field: 'getStatus()', displayName: 'Status' },
      ],
      rowTemplate: "<div ng-dblclick=\"grid.appScope.showModal(row)\" ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name\" " +
          "class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" ui-grid-cell></div>",

      appScopeProvider: {
        showModal : (row) => {
          vm.gridApi.selection.selectRow(row);
          $uibModal.open({
            controllerAs: 'vm',
            controller: 'userEditController',
            templateUrl: 'js/admin/editUserModal.html' + appVersion,
            animation: false,
            resolve: {
              user: () => row.entity,
            },
            size: 'lg'
          }).result.then(function(result) {
            if (result.delete) {
              Users.delete({userId: row.entity.userId}, function() {
                $scope.dnConfirmationMessage.$show('User ' + row.entity.userId + ' has been deleted.', 'danger');
                vm.userSearchGridOptions.data.splice(_.findIndex(vm.userSearchGridOptions.data, (user) => {
                  return user.userId === row.entity.userId;
                }), 1);
              });

            } else if (result.active !== undefined) {
              Users.updateStatus({userId: row.entity.userId, status: result.active ? 'active': 'inactive'}, function() {
                $scope.dnConfirmationMessage.$show("User " + row.entity.userId + " has been " +
                  (result.active ? 'activated' : 'inactivated') + ' successfully.',
                  !result.active ? 'warning' : undefined);
                row.entity.status = result.active ? 'active' : 'inactive';
              });

            }
          }, angular.noop);
        }
      },
      onRegisterApi: function(api) {
        vm.gridApi = api;
      }
    };

    function getTaxId() {
      /* jshint validthis: true */      
      if (!(this.taxIds && this.taxIds.length > 0)) {
        return '';
      }
      return this.taxIds.length > 1 ? 'Multiple' : (this.taxIds[0].substring(0, 2) + '-' + this.taxIds[0].substring(2));
    }
    function getStatus() {
      /* jshint validthis: true */
      if (!this.status) {
        return '';
      }
      return this.status.substring(0, 1).toUpperCase() + this.status.substring(1);
    }
    function submit() {
      $scope.errorControl.showErrors();
      if (!$scope.userSearchForm.$valid) {
        return;
      }
      $scope.errorControl.hideErrors();
      secSecurityService.ensureActiveSession().then(() => {
        /* The search users endpoint retuns data for unauthenticated users (for user search)
          so ensure their session is still active
        */
        vm.showGrid = true;
        vm.running = true;
        let criteria = _.mapValues(vm.model, (value, name) => {
          if (value) {
            if (name === 'dsoId') {
              return (_.find(vm.registeredDsos, (dso) => dso.name.toUpperCase() === value.toUpperCase()) || {}).id;
            } else {
              return value.split('*').join('%');
            }
          }
        });
        criteria.taxId && (criteria.taxId = criteria.taxId.split('-').join(''));
        Users.query(criteria, function(data) {
          vm.userSearchGridOptions.data = data.users;
          _.each(data.users, function(u) {
            u.getStatus = getStatus;
            u.getTaxId = getTaxId;
          });
          vm.running = false;
        }, function() {
          vm.running = false;
        });
      });
    }

    function reset() {
      $scope.errorControl.hideErrors();
      vm.userSearchGridOptions.data = [];
      vm.showGrid = false;
      vm.model = {};
    }
  }]);
})();
